import React from 'react';
import styled from 'styled-components';

const Loader = styled.div.attrs({ 'data-test': 'RouteLoader' })`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  opacity: 1;
  transition: width 0.4s, opacity 0.5s;
  width: 0;
  background-color: #c6f1ff;
  /* Should be above header */
  z-index: 107;
`;

class LoaderIndicator extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      visible: props.progress > 0 && props.progress < 1,
    };
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  componentDidUpdate() {
    clearTimeout(this.timer);

    if (this.props.progress === 1) {
      this.timer = setTimeout(() => {
        this.setState({ visible: false });
      }, 1000);
      return;
    }

    if (this.props.progress > 0) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ visible: true });
    }
  }

  render() {
    const { progress } = this.props;
    const { visible } = this.state;

    return (
      <Loader
        {...this.props}
        style={{
          width: visible ? `${progress * 100}%` : '0%',
          display: visible ? 'block' : 'none',
          opacity: visible && progress !== 1 ? 1 : 0,
        }}
      />
    );
  }
}

export default LoaderIndicator;
